import {isPointInRect} from "@Common/utils/2d/is-point-in-rect";
import {chain}         from "@Common/utils/fs";

export const getSmallestElemAt = (pos, target) => {
    return getSmallestElemAt1(pos, target)?.dom;
};

const getSmallestElemAt1 = (pos, target) => {
    const area = chain(
        target.getBoundingClientRect?.(),
        (rect) => rect && isPointInRect(pos, rect) && rect.width * rect.height,
    );
    let ret = area && {
        dom: target,
        area,
    };

    for (const child of target.childNodes) {
        const small = getSmallestElemAt1(pos, child);
        if (!ret || small && small.area <= ret.area) {
            ret = small;
        }
    }

    return ret;
};
